import Stack from 'atoms/Layout/Stack/Stack';
import BaseModal from 'molecules/BaseModal/BaseModal';
import React, { useEffect } from 'react';
import { getLocalStorage, setLocalStorage } from 'src/functions/localStorageHandler';
import {
  QUIZ_IFRAME_INTERACTION_STORAGE_KEY,
  QUIZ_SKIPPING_INTRO_ID,
  QUIZ_WITH_INTRO_ID,
} from 'src/hooks/usePricingQuizModalController';
import { IFrame, IFrameContainer, QuizContainer } from './PricingQuizModal.styles';

interface PricingQuizModalProps {
  visible: boolean;
  onClose: () => void;
  skipIntro: boolean;
}

const PricingQuizModal = ({ visible, onClose, skipIntro }: PricingQuizModalProps): JSX.Element => {
  const trackInteractionWithQuizIframe = (): void => {
    if (document.activeElement instanceof HTMLIFrameElement) {
      const hasInteracted = getLocalStorage(QUIZ_IFRAME_INTERACTION_STORAGE_KEY);

      if (hasInteracted === 'true') return;

      setLocalStorage(QUIZ_IFRAME_INTERACTION_STORAGE_KEY, 'true');
    }
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('blur', trackInteractionWithQuizIframe);

    return () => {
      window.removeEventListener('blur', trackInteractionWithQuizIframe);
    };
  }, []);

  const quizId = skipIntro ? QUIZ_SKIPPING_INTRO_ID : QUIZ_WITH_INTRO_ID;
  const quizUrl = `https://quiz.tryinteract.com/#/${quizId}${skipIntro ? '/q/1' : ''}?method=iframe`;

  return (
    <BaseModal
      visible={visible}
      onClose={onClose}
      baseWidth={600}
      hideCloseButton
      key={quizId}
    >
      <Stack
        justify='center'
        align='center'
        background='bg-primary'
        padding={['spacing-xl', 'spacing-md']}
        borderRadius='radius-md'
        overflow='hidden'
        boxSizing='content-box'
      >
        <QuizContainer
          position='relative'
          marginBottom='spacing-md'
        >
          <IFrameContainer>
            <IFrame
              id={`interactApp${quizId}`}
              width='100%'
              height='100%'
              src={quizUrl}
            />
          </IFrameContainer>
        </QuizContainer>
      </Stack>
    </BaseModal>
  );
};

export default PricingQuizModal;
